import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, MessagesSquare, LibraryBig } from "lucide-react";
import { Brand } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { scenariosFor } from "@/lib/manners";
import { PrintableCards } from "@/components/PrintableCards";
import { CARD_SETS } from "@/lib/cards";
import { Nice } from "@/components/Nice";

const ScenarioGroup = ({ title, items, testId }) => (
  <section className="mt-10" data-testid={testId}>
    <h2 className="pp-h2">{title}</h2>
    <div className="pp-scenario-grid mt-4">
      {items.map(({ id, icon: Icon, title: t, blurb }, i) => (
        <Link key={id} to={`/manners/${id}`} className="pp-scenario-tile" style={{ animationDelay: `${i * 80}ms` }}
          data-testid={`scenario-tile-${id}`}>
          <span className={`pp-scenario-icon s-${id}`}><Icon className="h-7 w-7" /></span>
          <h3 className="pp-h2">{t}</h3>
          <p className="opacity-75">{blurb}</p>
          <span className="pp-scenario-go">Start <ArrowRight className="h-4 w-4" /></span>
        </Link>
      ))}
    </div>
  </section>
);

export default function Manners() {
  const age = "kid";
  return (
    <div className={`pp-app mode-${age}`} data-testid="manners-page">
      <header className="pp-header">
        <Brand />
        <Link to="/" className="pp-ghost" data-testid="manners-back-link"><ArrowLeft className="h-4 w-4" /> Back to <Nice /></Link>
      </header>
      <main className="pp-main pp-wide">
        <p className="pp-label">Everyday manners</p>
        <h1 className="pp-h1">Practice manners for real life</h1>
        <p className="pp-sub max-w-xl">Learn the key manners, then practice with a friendly pretend helper. Speak or type, and earn acorns for your kind words.</p>
        <ScenarioGroup title="Kid corner" items={scenariosFor(age)} testId={`manners-group-${age}`} />
        <ScenarioGroup title="At school" items={scenariosFor("school")} testId="manners-group-school" />
        <ScenarioGroup title="For everyone" items={scenariosFor("all")} testId="manners-group-all" />
        <Link to="/dinner" className="pp-card pp-dinner-promo mt-8" data-testid="dinner-game-promo">
          <span className="pp-scenario-icon s-dinner"><MessagesSquare className="h-7 w-7" /></span>
          <div>
            <h2 className="pp-h2">Family Dinner Game</h2>
            <p className="opacity-75">Question cards that get everyone talking. A fun table ritual, devices away!</p>
          </div>
          <ArrowRight className="h-5 w-5 ml-auto" />
        </Link>
        <PrintableCards names={CARD_SETS.manners} title="Manners matter: cards for your family" />
        <Link to="/cards" className="pp-ghost mt-6" data-testid="manners-card-library-link"><LibraryBig className="h-4 w-4" /> See every card in the library</Link>
      </main>
      <Footer />
    </div>
  );
}
